import jwt from 'jwt-decode';
import { createSelector } from 'reselect';

import { State } from '../Store';

export const selectAuth = (state: State) => state.auth;

export const selectUserId = createSelector(
  [selectAuth],
  auth => {
    if (auth.authed && auth.token) {
      return jwt<{ sub: number }>(auth.token).sub;
    }

    return null;
  }
);
